module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', {
    attrs: {
      "id": "caminho"
    }
  }, [_vm._v("Você está aqui:\n    "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("AC El Salvador")]), _vm._v(" "), (_vm.menuselecionado == 'ccd-home') ? [_vm._v("\n      / "), _c('span', [_vm._v("Inicial")])] : [(_vm.menuselecionado == 'ccd-repositorio') ? [_vm._v("\n        / "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.mudarSelecao('ccd-home')
      }
    }
  }, [_vm._v("Repositório")]), _vm._v("\n        / "), _c('span', [_vm._v("AC " + _vm._s(_vm.acs[_vm.acselecionada].nome))])] : (_vm.menuselecionado == 'ccd-repositorio-psc') ? [_vm._v("\n        / "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.mudarSelecao('ccd-home')
      }
    }
  }, [_vm._v("Repositório")]), _vm._v("\n        / "), _c('span', [_vm._v("PSC " + _vm._s(_vm.pscs[_vm.pscselecionado].nome))])] : [_vm._v("\n        / "), _c('span', [_vm._v(_vm._s(_vm.menu[_vm.menuselecionado]))])]]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3048715e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = 98
// module chunks = 0